import {
  Directive,
  ElementRef,
  HostListener,
  Input
} from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[maxChars]'
})
export class MaxCharsDirective {
  @Input('maxChars') maxChars!: number;

  constructor(
    private el: ElementRef<HTMLInputElement | HTMLTextAreaElement>,
    private ngModel: NgModel
  ) {}

  @HostListener('input')
  onInput(): void {
    const element = this.el.nativeElement;
    const value = element.value ?? '';

    if (value.length > this.maxChars) {
      const truncated = value.substring(0, this.maxChars);
      element.value = truncated;

      this.ngModel.control.setValue(truncated, {
        emitEvent: false
      });
    }
  }
}
